import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';

import { IPagedRequest, IPagedResponse, IProfileOrder, PaymentStatus } from '../../shared/interfaces';
import { ApiService } from '../../shared/api.service';

@Component({
    selector: 'aza-rws-profile-orders',
    templateUrl: 'orders.component.html',
    styleUrls: ['orders.component.css'],
    standalone: false
})
export class OrdersComponent implements OnInit {
    pagedReq: IPagedRequest;
    orders: IProfileOrder[] = [];
    pagedResponseSubject = new Subject<IPagedResponse>();

    @Output() closed = new EventEmitter<void>();

    constructor(private apiSvc: ApiService) {
    }

    async ngOnInit(): Promise<void> {
        this.pagedReq = { limit: 5, offset: 0 };
        this.loadOrders(this.pagedReq);
    }

    async loadOrders(pagedReq: IPagedRequest): Promise<void> {
        const res = await this.apiSvc.getProfileOrders(pagedReq);
        this.orders = res.orders;
        this.pagedResponseSubject.next(res);
    }

    onPagingOffsetChanged(newOffset: number): void {
        this.pagedReq.offset = newOffset;
        this.loadOrders(this.pagedReq);
    }

    onClosed(): void {
        this.closed.next();
    }
}
